<template>
  <div class="container">
    <!-- 轮播图 -->
    <div class="title">
      <img class="imgList" v-lazy="gywmbaner" :key="gywmbaner" alt="" />
    </div>
    <div class="conCenOne">
        <div class="main">
          <div  class="conCenOneTitle">企业介绍</div>
          <div class="conCenOneLeft">
            <p  class="conCenOneLeftTitle">郑州时空 — 企业数智化整体解决方案服务商</p>
              <p>
               郑州时空成立于2002年，公司20多年来一直专注于以数字化、智能化推动企业进步，是国内领先的企业数智化整体解决方案服务商。
              </p>
              <p>郑州时空是中国最大的企业管理软件服务商联盟之一“数字时空医药”联盟的发起成员，是全国最大的企业互联网化服务联盟“幸福时空”的联合创始人及核心成员，创建了“5+15+30”的服务生态圈，始终坚定“客户成功、员工成长、企业成就”经营目标，秉持“高效专业、提升价值”的服务理念，“时空”品牌持续20年成为中国企业数智化服务的标杆。</p>
              <p>郑州时空将致力于以数智化推动企业进步，将数字化、智能化技术服务做为公司核心竞争力，在管理软件的开发实施服务、智能仓储物流设备集成、工业智能化设备等方面持续投入，为客户提供更全面的数智化解决方案，不断超越自我，追求卓越，成为国内一流的企业数智化整体解决方案服务商。</p>
          </div>

        </div>
    </div>
    <!-- 宣传 -->
    <div class="video">
      <iframe src="//player.bilibili.com/player.html?bvid=BV1XP411m7v3&page=1&high_quality=1" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true" > </iframe>
      <!-- <video controls autoplay muted playsinline loop>
         <source src="http://player.youku.com/embed/XNTk2MzgwMDkzMg" >
      </video> -->
      <!-- <iframe  src='https://player.youku.com/embed/XNTk2MzgwMDkzMg==' frameborder=0 ></iframe> -->
    </div>
    <!-- 使命 -->
    <div class="conCenTwoBox">
      <div class="conCenTwoBoxTitle">
        <p>核心价值观</p>
        <p class="conCenTwoBoxTitleEnd">CORE VALUES</p>
      </div>
      <div class="conCenTwo">
        <img v-lazy="twoPic" :key="twoPic" alt="">
      </div>
    </div>
       <!-- 时空实力 -->
    <div class="Three">
      <div class="ThreeTitle">
        <p>发展历程</p>
        <p class="ThreeTitleEnd">DEVELOPMENT COURSE</p>
      </div>
      <div class="ThreePic">
        <img v-lazy="threePic" :key="threePic" alt="">
      </div>
    </div>
    <div>
      <div class="four">
        <img v-lazy="four" :key="four" alt="">
      </div>
    </div>
      <!-- 时空实力结束 -->
      <!-- 合作伙伴title -->

      <!-- 合作伙伴 -->

  </div>
</template>

<script>
export default {
  name: 'aboutUs',
  data () {
    return {
      // 本地图片
      gywmbaner: require('./gywm/gywmbaner.png'),
      twoPic: require('./img/twoPic.png'),
      threePic: require('./img/threePic.png'),
      four: require('./img/four.png')

    }
  },

  mounted () {
  },
  methods: {
    // 默认图片

  }
}
</script>

<style lang="scss" scoped>
// pc高度比
// $sun:75/192;
$sun:100/192;
.container{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  .title{
    width: 100%;
    height: 460px*$sun;
  }
  .conCenOne {
    display: flex;
    // justify-content: center;
    width: 100%;
    padding-top: 60px*$sun;
    background: #FFFFFF;
    .main{
      width: 1400px*$sun;
      height: 402px*$sun;
      margin: auto;
      overflow: hidden;
      .conCenOneTitle{
        text-align: center;
        font-weight: 500;
        font-size: 40px*$sun;
      }
      .conCenOneLeft{
        // display: flex;
        // flex-direction: column;
        // justify-content: space-around;
        margin-top: 40px*$sun;
        height: 336px*$sun;
        font-size: 20px*$sun;
        color: #000;
        letter-spacing:2px*$sun;
        line-height:30px*$sun;
        p{
          margin: 0;
          font-weight: 500;
          margin-bottom: 20px*$sun;
          letter-spacing: 1.5px*$sun;
          line-height: 30px*$sun;
          color: #333;
        }
        .conCenOneLeftTitle{
          font-size: 28px*$sun;
          margin-bottom: 20px*$sun;
        }
      }
    }

  }
  // 视频
  .video{
    margin-top: 50px*$sun;
    width: 1400px*$sun;
    height: 790px*$sun;
    iframe{
      width: 100%;
      height: 100%;
    }
    video{
      width: 100%;
      height: 100%;

    }

  }
  // 使命
  .conCenTwoBox{
    width: 1400px*$sun;
    margin: auto;
    margin-top: 50px*$sun;
    height: 371px*$sun;
    .conCenTwoBoxTitle{
    margin-bottom: 30px*$sun;
      p{
        font-size: 22px*$sun;
        margin: 0;
        font-weight: 500;
      }
      .conCenTwoBoxTitleEnd{
        color: #999;
        font-size: 18px*$sun;
      }
    }
  }
  .conCenTwo{
    width: 1400px*$sun;
    height: 286px*$sun;
    margin: 0 auto;
    img{
      width: 100%;
      height: 100%;
    }
  }

  // 时空实力
  .Three{
    width: 1400px*$sun;
    margin: auto;
    margin-top: 50px*$sun;
    height: 505px*$sun;
    .ThreeTitle{
    margin-bottom: 30px*$sun;
      p{
        font-size: 22px*$sun;
        margin: 0;
        font-weight: 500;
      }
      .ThreeTitleEnd{
        color: #999;
        font-size: 18px*$sun;
      }
    }
  }
  .ThreePic{
    width: 1400px*$sun;
    height: 420px*$sun;
    margin: 0 auto;
    img{
      width: 100%;
      height: 100%;
    }
  }
  // 实力
  .four{
    width: 100%;
    height: 600px*$sun;
    margin-top: 80px*$sun;
    img{
      width: 100%;
      height: 100%;
    }
  }
}

.imgList {
  width: 100%;
  height:100%;
}
</style>
